import React from 'react';
import { motion } from 'framer-motion';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DownloadIcon from '@mui/icons-material/Download';
import MovieCard from '../MovieCard/MovieCard';
import './LatestSection.css';

const LatestSection = ({ featuredMovie, sideMovies }) => {
  return (
    <section className="latest-section" data-aos="fade-up">
      <div className="latest-section__header">
        <h3 className="latest-section__title">Latest</h3>
        <a href="/latest" className="latest-section__view-all">View All</a>
      </div>

      <div className="latest-section__grid">
        <motion.div 
          className="latest-section__featured"
          whileHover={{ scale: 1.02 }}
          data-aos="fade-right"
        >
          <div className="latest-section__featured-wrapper">
            <img 
              src={featuredMovie.poster} 
              alt={featuredMovie.title}
              className="latest-section__featured-image"
            />
            <div className="latest-section__featured-gradient latest-section__featured-gradient--vertical"></div>
            <div className="latest-section__featured-gradient latest-section__featured-gradient--horizontal"></div>
            
            {featuredMovie.isNew && (
              <div className="latest-section__badge">NEW</div>
            )}
            
            <div className="latest-section__featured-content">
              <h4 className="latest-section__featured-title">{featuredMovie.title}</h4>
              <div className="latest-section__featured-meta">
                <span>{featuredMovie.year}</span>
                <span> • </span>
                <span>{featuredMovie.genre}</span>
                <span> • </span>
                <span>{featuredMovie.duration}</span>
              </div>
              <p className="latest-section__featured-description">
                {featuredMovie.description}
              </p>
              <div className="latest-section__featured-actions">
                <button className="latest-section__button latest-section__button--primary">
                  Watch now
                </button>
                <button className="latest-section__button latest-section__button--secondary">
                  <DownloadIcon fontSize="small" />
                  Download
                </button>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="latest-section__side" data-aos="fade-left">
          {sideMovies.map((movie, index) => (
            <MovieCard 
              key={movie.id}
              movie={movie}
              variant="horizontal"
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestSection;